var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarehouseOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "warehouse-out",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m512 256c0 141.386719-114.613281 256-256 256s-256-114.613281-256-256 114.613281-256 256-256 256 114.613281 256 256zm0 0",
    fill: "#ff0335"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m512 256c0-8.417969-.417969-16.738281-1.214844-24.953125l-58.886718-58.886719-195.898438-122.875-195.898438 122.875 22.847657 36.425782 16.839843 16.789062v193.664062l82.03125 82.03125c23.480469 7.097657 48.382813 10.929688 74.179688 10.929688 141.386719 0 256-114.613281 256-256zm0 0",
    fill: "#9a0011"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m412.210938 175.933594-156.210938-98.753906-156.210938 98.753906v243.105468h312.421876zm0 0",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m412.210938 175.929688v243.109374h-156.210938v-341.859374zm0 0",
    fill: "#ffec98"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m429.050781 208.585938-173.050781-108.539063-173.050781 108.539063-22.847657-36.425782 195.898438-122.875 195.898438 122.875zm0 0",
    fill: "#84caff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m451.898438 172.160156-22.847657 36.429688-173.050781-108.539063v-50.761719zm0 0",
    fill: "#08f"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m148.316406 201.691406h215.367188v217.34375h-215.367188zm0 0",
    fill: "#ffb74f"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m256 201.691406h107.679688v217.347656h-107.679688zm0 0",
    fill: "#ff9a00"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m148.316406 226.582031h215.367188v23.6875h-215.367188zm0 0",
    fill: "#ff9a00"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m256 226.578125h107.679688v23.691406h-107.679688zm0 0",
    fill: "#e67500"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m148.316406 274.539062h215.367188v23.691407h-215.367188zm0 0",
    fill: "#ff9a00"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m256 274.539062h107.679688v23.691407h-107.679688zm0 0",
    fill: "#e67500"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m148.316406 322.496094h215.367188v23.691406h-215.367188zm0 0",
    fill: "#ff9a00"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m256 322.5h107.679688v23.691406h-107.679688zm0 0",
    fill: "#e67500"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m148.316406 370.453125h215.367188v23.691406h-215.367188zm0 0",
    fill: "#ff9a00"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m256 370.460938h107.679688v23.679687h-107.679688zm0 0",
    fill: "#e67500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehouseOut);
export default __webpack_public_path__ + "static/media/warehouse-out.02210cecca779de1a6f54f74c5adef66.svg";
export { ForwardRef as ReactComponent };